import { Formik, useFormik } from 'formik'
import React, { useEffect, useMemo, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from "react-loading";

import { Link, Navigate } from 'react-router-dom'
import './auth.css'
import { NavBarScreen } from '../navBar/NavBarScreen';
import { FooterScreen } from '../footer/FooterScreen';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'universal-cookie/es6';
import { useForm } from '../../hooks/useForm';
import { chekingAutentication } from '../../store/auth/thunks';
import { requestRole } from '../../functions/requestRole';
import { requestEnterprise } from '../../functions/requestEnterprise';
import { PreLoader } from '../initialsPages/PreLoader';
import axios from 'axios';
import { ApiUrl } from '../../services/ApiRest';


const cookies = new Cookies();
// const rol = cookies.get('rol');
var rol = '';
// var enterprise = {};
// const islogged = cookies.get('log');




export const LoginScreenClient = () => {

    const [isLoading, setisLoading] = useState(false)
    const [errorMessage, seterrorMessage] = useState(null)
    const [formD, setformD] = useState({
        email: '',
        password: '',
    });

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setformD({
            ...formD,
            [name]: value
        })
    }


    const loadUser = async () => {
        var token = localStorage.getItem('access_token')
        console.log(token)
        axios.get(ApiUrl + "passenger/profile", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                window.location.href = "/subscriber/home";
                // console.log("APROBADOOOOOOO1111")
            })
            .catch(() => {
                // Token inválido o expirado, mostrar login
                localStorage.removeItem('access_token');
                // console.log("REPROBADO")
                // Navigate('/login');

            });


    }

    const onSubmit = async (event) => {
        event.preventDefault();
        setisLoading(true);
        seterrorMessage(null); // Limpiar errores previos

        const f = new FormData();

        f.append("email", formD.email);
        f.append("password", formD.password);

        await axios.post(ApiUrl + "loginClient", f)
            .then(response => {
                console.log(response.data.access_token)
                if (response.data.success === true) {
                    localStorage.setItem('access_token', response.data.access_token);
                    loadUser();

                } else if (response.success === false) {
                    seterrorMessage(response.data.message || "Error al iniciar sesión.");
                }

                setisLoading(false);
            })
            .catch(error => {

                if (error.response) {
                    // Error recibido desde el servidor (404, 401, 422, etc.)
                    seterrorMessage(
                        error.response.data.message || "Error inesperado en el servidor."
                    );
                } else if (error.request) {
                    // No hubo respuesta
                    seterrorMessage("El servidor no respondió. Intenta más tarde.");
                } else {
                    // Otro error
                    seterrorMessage("Error al procesar la solicitud.");
                }
                setisLoading(false);
            })
    }


    // return (<PreLoader />)


    return (
        <>
            <NavBarScreen />
            <div className='fondo-login' style={{
                backgroundImage: `url('../assets/images/fondos/fondo4.png')`
            }}
            >
                {/* <div className='fondo-register ' > */}
                <div className="container" style={{ width: "85%", paddingBottom: '10vh' }}>
                    <div className="row justify-content-center " style={{ paddingTop: '25vh' }}>
                        <div className=" col-xs-12 col-lg-5 col-xl-5 color-istmas">
                            <div className="card shadow p-3 mb-5 bg-white form-fondo">
                                <div className="card-header text-center">
                                    <h3 className='camping-letters text-center' style={{ color: "white" }}>Comencemos!  </h3>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={onSubmit} >

                                        <div className='row'>
                                            <div className="col-12 col-sm-12" style={{ paddingTop: '2vh' }}>
                                                <label className="form-label"><b>Correo</b></label>
                                                <input type="email" onChange={onInputChange} name='email' value={formD.email} className="form-control" placeholder='Ej: usuario@gmail.com' aria-describedby="textHelp" required></input>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className="col-12 col-sm-12" style={{ paddingTop: '2vh' }}>
                                                <label className="form-label"><b>Contraseña</b></label>
                                                <input type="password" onChange={onInputChange} name='password' value={formD.password} className="form-control" aria-describedby="textHelp" placeholder='********' required></input>
                                            </div>

                                        </div>

                                        <div className="text-center" style={{ paddingTop: '2vh' }}>
                                            {
                                                (errorMessage !== null)
                                                    ?
                                                    <div className="alert alert-danger" role="alert">
                                                        {errorMessage}
                                                    </div>
                                                    :
                                                    <></>
                                            }

                                            <button type="submit" disabled={isLoading} className="btn  btn btn-success " style={{ margin: "5px", width: "180px" }} > <b>Iniciar Sesión</b></button>
                                            <Link to="/">
                                                <button type="" className="btn  btn btn-dark " style={{ margin: "5px", width: "180px" }}  ><b>Cancelar </b></button>
                                            </Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div style={{ textAlign: "center" }}>
                                <label style={{ textAlign: "center", color: "white" }}>Core 1.0.11</label>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer theme="colored" />
                {/* <FooterScreen/> */}
            </div>

            <FooterScreen />
        </>
    )
    // }
}


const fullScreenContainer = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw', // 100% of the viewport width
    height: '100vh', // 100% of the viewport height
    position: 'fixed', // Makes sure it covers the whole screen
    top: 0,
    left: 0,
    zIndex: 9999, // Ensures it is on top
    // backgroundColor:"Black"
};